export const updateFilterElement = (filterElement) => {
    return (dispatch, getState) => {
        dispatch({ type: 'FILTER_ELEMENT_UPDATE', filterElement })
    }
}
